// Qonaq quiz-i bitirib qeydiyyata yönləndikdə sessiya məlumatı burada saxlanılır;
// login/register uğurlu olan kimi claim olunub kupon alınır.
const KEY = "quizzo_pending_claim";

export const setPendingClaim = ({ sessionId, guestToken }) => {
  localStorage.setItem(KEY, JSON.stringify({ sessionId, guestToken }));
};

export const getPendingClaim = () => {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const clearPendingClaim = () => localStorage.removeItem(KEY);
